import config from '../services/config';
export var recordingBatch = function recordingBatch(siteApi, getToken) {
  return {
    index: function index(params) {
      if (params === void 0) {
        params = {};
      }
      return siteApi.get('/recording-batch', {
        params: params
      });
    },
    get: function get(id) {
      return siteApi.get("/recording-batch/".concat(id));
    },
    getDownloadUrl: function getDownloadUrl(id) {
      return "".concat(config.api.url, "/recording-batch/").concat(id, "/download?token=").concat(getToken().accessToken);
    }
  };
};